export const normalizeSteps = (data) => {
    const rawSteps = Array.isArray(data?.steps) ? data.steps : []
    const steps = rawSteps
        .filter((step) => step && step.component && step.port)
        .slice()
        .sort((a, b) => (a.stepNumber || 0) - (b.stepNumber || 0))

    const totalSteps = Number(data?.totalSteps || steps.length || 0)

    // Whether the player's "Next" button is usable. Defaults to false so that
    // tutorials created before this feature keep the Next button disabled until
    // an admin explicitly opts in.
    const nextAllowed = data?.nextAllowed === undefined ? false : data.nextAllowed

    return {
        ...data,
        steps,
        totalSteps,
        nextAllowed,
    }
}

export const fetchAssemblySteps = async (apiProjectId, isPreview, screenId) => {
    if (!apiProjectId) {
        throw new Error('apiProjectId is required to fetch assembly steps')
    }

    const BACKEND_URL = process.env.REACT_APP_API_BASE || ''

    // 1. Build the base path
    let endpoint = isPreview
        ? `${BACKEND_URL}/api/staging/assembly/${apiProjectId}`
        : `${BACKEND_URL}/api/assembly/${apiProjectId}`

    // 2. Append the screenId if it exists (e.g., /api/staging/assembly/talking-dragon/assembly2)
    if (screenId) {
        endpoint += `/${screenId}`
    }

    const response = isPreview 
        ? await fetch(endpoint, { credentials: 'include' }) 
        : await fetch(endpoint)

    if (!response.ok) {
        throw new Error(`Assembly steps request failed: ${response.status}`)
    }

    const data = await response.json()
    return normalizeSteps(data)
}
